import { DEVICES } from 'src/constants/Constants'
import {
  DEVICE_DATA,
  PRINTER_DATA,
  PRINT_SERVER_DATA,
  SCALE_DATA,
  SET_DEVICES,
} from '../actions/actionType'
const initialState = {
  devices: { printer: '', scale: '', unit: 'lb' },
  printers: [],
  scales: [],
  printServers: [],
  isLocalServiceAvailable: true,
}
export default function DeviceReducer(state = initialState, action) {
  switch (action.type) {
    case PRINTER_DATA:
      return { ...state, printers: action.payload }
    case SCALE_DATA:
      return { ...state, scales: action.payload }
    case DEVICE_DATA:
      return {
        ...state,
        devices: action.payload.devices,
        isLocalServiceAvailable: action.payload.isLocalServiceAvailable,
      }
    case PRINT_SERVER_DATA:
      return { ...state, printServers: action.payload }
    case SET_DEVICES:
      localStorage.setItem(DEVICES, JSON.stringify(action.payload))
      return { ...state, devices: action.payload }
    default:
      return state
  }
}
